import explore from "./en-US/explore";
import filter from "./en-US/filter";

export default {
  ...explore,
  ...filter,
};
